import AxiosInstance from "../config/AxiosInstance";

const getDeviceUserRole = async (payload: any) => {
    try {
        const { data } = await AxiosInstance.get('/api/device-user-role/list', {
            params: {
                page: payload.page,
                limit: payload.limit,
                searchValue: payload.searchValue
            }
        });
        return { data };
    } catch (error) {
        throw error;
    }
};

const getDetailsDeviceUserRole = async (id: string, userId: string) => {
    try {
        const { data } = await AxiosInstance.get('/api/device-user-role/find-one/' + id);
        return { data };
    } catch (error) {
        throw error;
    }
};

const createDeviceUserRole = async (payload: any) => {
    try {
        const { data } = await AxiosInstance.post('/api/device-user-role', payload);
        return { data };
    } catch (error) {
        throw error;
    }
};

const updateDeviceUserRole = async (id: string, payload: any) => {
    try {
        const { data } = await AxiosInstance.put('/api/device-user-role/' + id, payload);
        return { data };
    } catch (error) {
        throw error;
    }
};

const deleteDeviceUserRole = async (id: string) => {
    try {
        const { data } = await AxiosInstance.delete('/api/device-user-role/' + id);
        return { data };
    } catch (error) {
        throw error;
    }
};

const getListDeviceUserRole = async () => {
    try {
        const { data } = await AxiosInstance.get('/api/modules/list');
        return { data };
    } catch (error) {
        throw error;
    }
}

export {
    getDeviceUserRole,
    getDetailsDeviceUserRole,
    createDeviceUserRole,
    updateDeviceUserRole,
    getListDeviceUserRole,
    deleteDeviceUserRole
}